import { useNavigationManager } from '@Router/useNavigationManager';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { SUBMIT_BUTTON_ID } from '@Types/consts.ts';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-hook-form';
import React, { memo } from 'react';
import { ExtendedUseFormReturn } from '@Hooks/index';
import { useResizeListener } from '@Hooks/custom/useResizeListener.ts';

interface IFormFooterProps {
  isLoading: boolean;
  onSubmit: () => void;
  maxWidth?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formMethods: ExtendedUseFormReturn<any>;
  customBackHandling?: () => void;
  customSubmitTitle?: string;
  footerInputSlot?: React.ReactNode;
  shouldStrechCta?: boolean;
}

export const FormFooter = memo((props: IFormFooterProps) => {
  const { t } = useTranslation();
  const { isValid } = useFormState({ control: props.formMethods.control });
  const { navigateToPreviousPage, isAllowedNextPage, isAllowedPrevPage, isNavigationHidden } =
    useNavigationManager();
  const { isMobile } = useResizeListener();

  const getDynamicMobileLayout = () => {
    if (props.footerInputSlot) {
      return 'w-full flex flex-col pc-sm:flex-row items-center justify-between gap-[20px] mx-auto';
    } else {
      return 'w-full flex items-center justify-between mx-auto';
    }
  };

  return isMobile && !isAllowedNextPage ? null : !isNavigationHidden ? (
    <div
      className='w-full p-[16px] md:p-[24px] z-40 bg-surface-primary-bw-00 sm:block shrink-0 border-t border-outline-primary-bw-03'
      id='page-footer'>
      <div
        style={{ maxWidth: props.maxWidth ? `${props.maxWidth}px` : '500px' }}
        className={getDynamicMobileLayout()}>
        {props.footerInputSlot ? (
          props.footerInputSlot
        ) : (
          <div
            className={
              !isAllowedPrevPage
                ? 'hidden-placeholder'
                : 'hidden sm:block sm:opacity-1 sm:pointer-events-auto w-[115px]'
            }>
            <LiliButton
              onClick={props.customBackHandling || navigateToPreviousPage}
              title='Back'
              id='back'
              type={LiliButtonType.SECONDARY}
            />
          </div>
        )}

        <div
          className={` ${!isAllowedNextPage ? 'hidden-placeholder' : `w-full min-w-[115px] ${!props.shouldStrechCta ? 'sm:w-fit' : ''}`}`}>
          <LiliButton
            onClick={() => props.onSubmit()}
            isLoading={props.isLoading}
            disabled={!isValid || props.isLoading}
            id={SUBMIT_BUTTON_ID}
            type={LiliButtonType.PRIMARY}
            title={props.customSubmitTitle || t('global.FORM_SUBMIT')}
          />
        </div>
      </div>
    </div>
  ) : null;
});
